"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lines_1 = require("../lines");
var PettyCashLineResource = /** @class */ (function (_super) {
    tslib_1.__extends(PettyCashLineResource, _super);
    function PettyCashLineResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PettyCashLineResource.endpoint = '/lines/pc';
    PettyCashLineResource.MODEL_NAME = 'pettycashline';
    return PettyCashLineResource;
}(lines_1.BaseLineResource));
exports.default = PettyCashLineResource;
//# sourceMappingURL=lines.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/pc/lines.js
// module id = mvYA
// module chunks = 0